module.exports = __webpack_public_path__ + "img/google_play.b75537dd.png";